import { Model } from 'types';

export const getTitleFromModel = (model: Model) => {
  const titleParts = [model.brand.name, model.name, model.referenceNumber].filter(t => t);
  const title = titleParts.join(' ');

  return title;
};
